module.exports = __webpack_public_path__ + "app-static/img/p_01.d010fa05.jpg";